import { Calculator } from 'lucide-react'

export function AppraisalEngineHeader() {
  return (
    <section className="mb-6 flex items-center rounded-xl border border-border bg-card p-5 shadow-sm">
      <div>
        <h2 className="flex items-center gap-2 text-sm font-bold text-foreground">
          <Calculator aria-hidden="true" className="h-4 w-4 text-primary" />
          Appraisal Engine
          <span className="ml-2 rounded bg-primary/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-primary">
            Live
          </span>
        </h2>
        <p className="mt-1 text-xs font-medium text-muted-foreground">
          Reverse-engineer the maximum purchase price based on your target return
        </p>
      </div>
    </section>
  )
}
